"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPointsAutoTestStep = void 0;
const base_1 = require("./base");
const utils_1 = require("./utils");
class CheckPointsAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave(context) {
        const errs = [];
        if (context.totalWeight <= 0) {
            errs.push('The total weight of all steps before a checkpoint must be positive.');
        }
        if (context.remainingSteps <= 0) {
            errs.push('The last step of a suite may not be a checkpoint.');
        }
        if (this.data.minPoints < 0) {
            errs.push('The minimal percentage must be greater than 0.');
        }
        else if (this.data.minPoints > 1) {
            errs.push('The mimimal percentage must be less than or equal to 100.');
        }
        const extra = (0, utils_1.errOrData)(errs, { type: this.type, data: this.data, weight: 0 });
        return (0, utils_1.mergeEithers)(this._baseGetDataToSave(), extra);
    }
}
exports.CheckPointsAutoTestStep = CheckPointsAutoTestStep;
